import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FaPhone, FaMapMarkerAlt, FaWhatsapp, FaArrowRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { ClimbingBoxLoader } from 'react-spinners';

const ImageSlider = ({ photos }) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('email') == null && localStorage.getItem('password') == null) {
      navigate('/login');
    }
  }, []);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const handleCall = (pno) => {
    window.location.href(`tel: ${pno}`);
  };

  const handleWhatsApp = (wno) => {
    // Implement the WhatsApp functionality here
  };

  const handleLocation = (loc) => {
    // Implement the location functionality here
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const nextImage = () => {
    setCurrentImage((prevImage) => (prevImage + 1) % photos.length);
  };

  const prevImage = () => {
    setCurrentImage((prevImage) => (prevImage - 1 + photos.length) % photos.length);
  };

  return (
    <div className="relative max-w-full overflow-hidden h-96">
      <button className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded" onClick={prevImage}>
        &lt;
      </button>
      <img src={photos[currentImage]} alt={`Room ${currentImage + 1}`} className="rounded-lg shadow-md w-full h-full object-cover cursor-pointer" onClick={openModal} />
      <button className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded" onClick={nextImage}>
        &gt;
      </button>

      {isModalOpen && (
        <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-75" onClick={closeModal}>
          <img src={photos[currentImage]} alt={`Room ${currentImage + 1}`} className="rounded-lg shadow-md max-w-full max-h-full" />
        </div>
      )}
    </div>
  );
};

export const Roomdetails = () => {
  const { roomId } = useParams();
  const [roomDetails, setRoomDetails] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [isrequested, setisrequested] = useState(false);
  const [isapproved, setisapproved] = useState(false);
  const [requestStatus, setRequestStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleCall = (pno) => {
    window.open(`tel:${pno}`, '_blank');
  };
  
  const handleWhatsApp = (wno) => {
    
    const whatsappUrl = `https://wa.me/${wno}`;
    window.open(whatsappUrl, '_blank');
  };

  

  useEffect(() => {
    const fetchRoomStatus = async () => {
      try {
        const response = await fetch('https://pgdost.onrender.com/api/getstatus', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            roomId,
            userEmail: localStorage.getItem('email'),
          }),
        });

        const data = await response.json();

        if (data.status === 'rejected') {
          setRequestStatus('rejected');
        } else if (data.status === 'approved') {
          setRequestStatus('approved');
          setisapproved(true);
        } else if (data.status === 'pending') {
          setRequestStatus('pending');
        }
      } catch (error) {
        console.error('Error checking room status:', error);
      }
    };

    fetchRoomStatus();
  }, [roomId]);

  const handleApproval = async () => {
    try {
      const response = await fetch('https://pgdost.onrender.com/api/request-room', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          roomId,
          userEmail: localStorage.getItem('email'),
          requestedto: userDetails.email,
          requestedby:localStorage.getItem('email'),
        }),
      });

      const data = await response.json();

      if (data.status === 'pending') {
        setRequestStatus('pending');
      } else if (data.status === 'duplicate') {
        setRequestStatus('duplicate');
      } else if (data.status === 'approved') {
        setRequestStatus('approved');
      } else {
        setRequestStatus('');
      }
    } catch (error) {
      console.error('Error initiating room request:', error);
    }
  };

  useEffect(() => {
    const fetchRoomDetails = async () => {
      try {
        const roomResponse = await fetch(`https://pgdost.onrender.com/api/rooms/${roomId}`);
        const roomData = await roomResponse.json();
        setRoomDetails(roomData);

        if (roomData && roomData.roomemail) {
          const userResponse = await fetch(`https://pgdost.onrender.com/api/currentuser?email=${roomData.roomemail}`);
          const userData = await userResponse.json();
          setUserDetails(userData);
        }
      } catch (error) {
        console.error('Error fetching details:', error);
      }
    };

    fetchRoomDetails();
  }, [roomId]);

  if (!roomDetails || !userDetails) {
    return <div className="w-full flex items-center justify-center h-64 ">
    {/* Center the loading spinner */}
    
    <ClimbingBoxLoader color="rgba(54, 89, 214, 1)" size={29} />
  </div>;
  }

  return (
    <div className="container mx-auto p-8 mt-8 bg-gray-100">
      <div className="bg-white rounded-lg shadow-md p-6">
        <h1 className="text-4xl font-bold mb-4 text-indigo-600">{roomDetails.pgName}</h1>
        <p className="text-lg mb-4 text-gray-700">Rent: ₹{roomDetails.roomRent}/month</p>

        <ImageSlider photos={roomDetails.photos} />

        <div className="mb-8">
          <h2 className="text-2xl font-bold mb-2 text-indigo-600">Room Details</h2>
          <p className="text-lg mb-2 text-gray-700">Rent: ₹{roomDetails.roomRent}/month</p>
          <p className="text-lg mb-2 text-gray-700">Pg Name: {roomDetails.pgName}</p>
          <p className="text-lg mb-2 text-gray-700">Location: {roomDetails.locationurl}</p>
          <p className="text-lg mb-2 text-gray-700">Room Features:</p>
          <div className="grid grid-cols-2 gap-4">
            <Checkbox label="AC" checked={roomDetails.AC} />
            <Checkbox label="Wifi" checked={roomDetails.Wifi} />
            <Checkbox label="Electricity Backup" checked={roomDetails.Electricity} />
            <Checkbox label="RO Purifier" checked={roomDetails.RO} />
          </div>
        </div>

        <div className="mb-8 p-6 bg-white rounded-lg shadow-md">
  <img src={userDetails.profilePic} className="w-24 h-auto mb-4 rounded-full " alt="Profile Pic" />
  <h2 className="text-2xl font-bold mb-2 text-indigo-600">Hosted by {userDetails.name}</h2>
  
  <p className="text-lg mb-2 text-gray-700">Course Name: {userDetails.courseName}</p>
  <p className="text-lg mb-2 text-gray-700">Course Code: {userDetails.courseCode}</p>
  <p className="text-lg mb-2 text-gray-700">Semester: {userDetails.semester}</p>
</div>


        {!isapproved && !isrequested && !requestStatus && (
          <div className="flex space-x-4">
            <ActionButton color="blue" text="Request For the Contact Details" onClick={handleApproval} />
          </div>
        )}

        {requestStatus === 'pending' && (
          <div className="text-blue-500 mt-2">Your request is pending approval.</div>
        )}

        {requestStatus === 'rejected' && (
          <div className="text-red-500 mt-2">Your request is rejected.</div>
        )}

        {isapproved && (
          <div className="flex space-x-4">
            <ActionButton color="blue" text="Call" onClick={() => handleCall(roomDetails.phno)} />
            {roomDetails.whatsappenabled && (
              <ActionButton color="green" text="WhatsApp" onClick={() => handleWhatsApp(roomDetails.phno)} />
            )}
           
          </div>
        )}
      </div>
    </div>
  );
};

const Checkbox = ({ label, checked }) => (
  <div className="flex items-center text-gray-700">
    <input type="checkbox" checked={checked} className="mr-2 form-checkbox h-5 w-5 text-indigo-600" readOnly />
    {label}
  </div>
);

const ActionButton = ({ color, text, onClick }) => (
  <button className={`bg-${color}-500 text-white px-4 py-2 rounded-lg`} onClick={onClick}>
    {text}
  </button>
);
